export enum SupersetType {
	None = 0,
	FirstIsSuperset = 1,
	SecondIsSuperset = 2,
}
